import {
	formatMetricKilometres,
	formatMetricKilowattHour,
} from '@anwb/poncho/utilities/formatters';
import { GearType, GearTypeKey, KeyValuePair, Upgrade } from 'types';
import { getInteriorColorAndFabric, getInteriorFabricFromEquipment } from 'utils';

export const getSpecsForModal = (upgrade: Upgrade, interiorColor: string): KeyValuePair[] => {
	const {
		enginePowerHP,
		enginePowerKW,
		range,
		batteryCapacity,
		gearType,
		fuelType,
		doors,
		standardEquipment,
	} = upgrade.vehicleData;

	const interiorFabric = getInteriorFabricFromEquipment(standardEquipment);
	const specs = [];

	if (enginePowerHP && enginePowerKW) {
		specs.push({
			key: 'Vermogen',
			value: `${enginePowerKW} kW (${enginePowerHP} pk)`,
		});
	}

	if (fuelType === 'VE' && batteryCapacity && range) {
		specs.push(
			{
				key: 'Actieradius (fabrieksopgave)',
				value: formatMetricKilometres(Number(range), {
					fallback: '-',
				}) as string,
			},
			{
				key: 'Accucapaciteit',
				value: formatMetricKilowattHour(Number(batteryCapacity), {
					fallback: '-',
				}) as string,
			}
		);
	}

	if (gearType) {
		specs.push({
			key: 'Transmissie',
			value: GearType[gearType as GearTypeKey] || '-',
		});
	}

	if (doors) {
		specs.push({
			key: 'Aantal deuren',
			value: doors,
		});
	}

	if (interiorFabric || interiorColor) {
		specs.push({
			key: 'Bekleding',
			value: getInteriorColorAndFabric(interiorFabric, interiorColor),
		});
	}

	return specs;
};
